<template>
	<div class="box">
		<div class="col-4">
			<div class="setHeight">
				<div class="wjTypeChild" :style="{ height: height + 'px' }">
					<div
						v-for="(operate, index) in tx_setting"
						:key="operate.id"
						style="text-align: center"
						class="wjTypeChildItemFont"
						:class="{
							wjTypeChildItem: index != 0,
							iconActive: operate.id == activeIndex
						}"
						@click="toJump(operate)"
					>
						<!-- <router-link
              :to="{ path: operate.path }" > -->
						<div class="icon activebox_box" v-show="operate.show">
							<img :src="operate.icon2" v-if="operate.id == activeIndex" style="margin-top: 12px" class="activebox_box_img1" alt="" />
							<img class="activebox_box_img2" :src="operate.icon" v-else style="margin-top: 12px !important" />
						</div>
						<span class="iconSpan" v-show="operate.show">{{ operate.label }}</span>
						<!-- </router-link> -->
					</div>
				</div>

				<div class="content">
					<!-- <keep-alive> -->
					<router-view style="background-color: #fff; min-width: 1030px"></router-view>
					<!-- </keep-alive> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ExamQuestionBankLeft',
	data() {
		return {
			tx_setting: [
				{
					id: '1',
					label: '我的题库',
					icon: require('@/assets/tx/tab_def_icon1.png'),
					icon2: require('@/assets/tx/tab_sel_icon1.png'),
					path: '/myQuestionBank',
					active: true,
					show: true
				},
				{
					id: '2',
					label: '系统题库',
					icon: require('@/assets/tx/tab_def_icon4.png'),
					icon2: require('@/assets/tx/tab_sel_icon4.png'),
					path: '/systemQuestionBank',
					active: false,
					show: false
				},
				{
					id: '3',
					label: '试题管理',
					icon: require('@/assets/tx/tab_def_icon5.png'),
					icon2: require('@/assets/tx/tab_sel_icon5.png'),
					path: '/testQuestionManagement',
					active: false,
					show: false
				},
				{
					id: '4',
					label: '标签管理',
					icon: require('@/assets/Problemlabel.png'),
					icon2: require('@/assets/Problemlabel3.png'),
					path: '/kslabelManagement',
					active: false,
					show: true
				}
			],
			height: 0
		};
	},
	computed: {
		activeIndex: {
			get() {
				switch (this.$route.path) {
					case '/myQuestionBank':
						return '1';
					case '/addQuestionBank':
					case '/addTestQuestions':
						if(this.$route.query.questionBank == 1) {
							return '1';
						} else {
							return '2';
						}
					case '/systemQuestionBank':
						return '2';
					case '/testQuestionManagement':
						return '3';
					case '/kslabelManagement':
						return '4';
					default:
						return '1';
				}
			},
			set(v) {
				return v;
			}
		}
	},
	created() {
		this.accessPermission();
	},
	mounted() {
		var winHeight = document.body.clientHeight || document.documentElement.clientHeight;
		this.height = winHeight - 108;
		this.rightheight = winHeight - 60;
		window.onresize = () => {
			var winHeight = document.body.clientHeight || document.documentElement.clientHeight;
			this.height = winHeight - 108;
			this.rightheight = winHeight - 60;
		};
	},
	methods: {
		toJump(item) {
			this.$router.push({ path: item.path });
		},
		accessPermission() {
			let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
			// console.log(userInfo.permissionList);
			let arr = userInfo.permissionList;
			let permissionList = {};
			arr.forEach((item, index) => {
				permissionList['admin' + item] = item;
			});
			console.log(permissionList);
			// this.permissionList = permissionList;
			this.tx_setting.forEach(item => {
				// 系统题库
				if (permissionList.admin1033) {
					if (item.id == 2) {
						item.show = true;
					}
				} else {
					if (item.id == 2) {
						item.show = false;
					}
				}
				// 试题管理
				if (permissionList.admin1034) {
					if (item.id == 3) {
						item.show = true;
					}
				} else {
					if (item.id == 3) {
						item.show = false;
					}
				}
			});
		}
	}
};
</script>

<style scoped>
.box {
	background-color: #f2f2f2;
	padding-top: 1px;
}
.content {
	width: calc(100% - 80px);
}
.iconActive span {
	color: #0080ff;
}
.iconActive .icon {
	background-color: #0080ff;
}
.wjTypeChild {
	width: 80px;
	background-color: #fff;
	padding-top: 15px;
	padding-bottom: 30px;
	display: inline;
	border-right: 1px solid #f2f2f2;
}
.wjTypeChildItem {
	text-align: center;
	margin-top: 40px;
}
.icon {
	margin: 0px auto;
	width: 50px;
	height: 50px;
	border-radius: 5px;
}
.wjTypeChildItemFont {
	font-size: 14px;
	cursor: pointer;
}
.iconSpan {
	color: #666;
}
.setHeight {
	height: 100%;
	background-color: #fff;
	margin-top: 1px;
	display: flex;
}
</style>
